<!-- 组件模板内容 -->
<template>
  <div>
    <div id="myTabContent" class="tab-content">
      <div
          v-loading="loading"
          class="card mb-5 mb-xl-8"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-spinner="el-icon-loading"
          element-loading-text="拼命加载中"
          style="margin-left: 3px; width: 100%"
      >
        <div class="card-body py-3">
          <div class="table-responsive">
            <table
                id="kt_ecommerce_products_table"
                class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
            >
              <thead>
              <tr
                  class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
              >
                <th
                    aria-label="order_batch"
                    class="text-center min-w-50px"
                    colspan="1"
                    rowspan="1"
                    style="width: 212.141px"
                    tabindex="0"
                >
                  会员名称
                </th>
                <th
                    aria-label="product_name"
                    class="text-center min-w-150px"
                    colspan="1"
                    rowspan="1"
                    style="width: 106.344px"
                    tabindex="0"
                >
                  会员电话
                </th>
                <th
                    aria-label="market_price"
                    class="text-center min-w-40px"
                    colspan="1"
                    rowspan="1"
                    style="width: 106.344px"
                    tabindex="0"
                >
                  会员积分
                </th>
                <th
                    aria-label="order_time"
                    class="text-center min-w-60px"
                    colspan="1"
                    rowspan="1"
                    style="width: 106.344px"
                    tabindex="0"
                >
                  注册时间
                </th>
                <th
                    aria-label="operation"
                    class="text-center sorting_disabled"
                    colspan="1"
                    rowspan="1"
                    style="width: 120px"
                >
                  操作
                </th>
              </tr>
              </thead>
              <tbody class="fw-semibold text-gray-600">
              <tr
                  v-for="(item, index) in rows"
                  :key="index"
                  :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
              >

                <td class="text-center pe-0">
                  <span :title="item.title"
                        class=""
                        style="overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        line-height: 1.2;">{{ item.name }}</span>
                </td>
                <!-- 商品名称 -->
                <td class="text-center pe-0">
                  <span :title="item.title"
                        class=""
                        style="overflow: hidden;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        line-height: 1.2;">{{ item.tel }}</span>
                </td>
                <!-- 市场价 -->
                <td class="text-center pe-0">
                  <span class="fw-bold">{{ item.score | format }}</span>
                </td>

                <!--下单时间-->
                <td class="text-center pe-0" style="font-size: 10px">
                  <span>{{ item.crTime }}</span>
                </td>

                <!-- 操作 -->
<!--                <td class="text-center">
                  <a
                      class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary"
                      data-kt-menu-placement="bottom-end"
                      data-kt-menu-trigger="click"
                      href="javascript:void(0)"
                      @click="toggleDropdown(index)"
                  >
                    操作
                    <i class="ki-outline ki-down fs-5 ms-1"></i>
                  </a>
                  <div
                      :id="'dropdown-' + index"
                      class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                      data-kt-menu="true"
                  >
                    &lt;!&ndash; v-if="item.orderTypeName == '待发货' && item.dataForm == '1'" &ndash;&gt;

                    <div
                        class="menu-item px-3"
                    >
                      <a
                          class="menu-link px-3"
                          href="javascript:void(0)"
                          @click="updateOrderDelivery(item.orderNo)"
                      >查看订单</a
                      >
                    </div>


                  </div>
                </td>-->
                <td>
                  <a class="btn btn-success btn-sm px-4 mx-sm-1 my-sm-1"
                     @click="editGoods(item.id)">&nbsp;查看订单</a>
                </td>
              </tr>
              </tbody>
            </table>
            <Pagination
                v-if="hidden"
                ref="Pagination"
                :total-items="totalCount"
                @page-change="pageChange"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品的弹窗 -->
    <el-dialog v-if="vipOrderVisible" :visible.sync="vipOrderVisible" append-to-body=true title="结算订单管理"
               width="90%">
      <template #title>
        <div class="modal-content">
          <div class="modal-header">
            <h2>结算订单管理</h2>
          </div>
        </div>
      </template>
      <vipOrderModal :currentTopicId="bingId"></vipOrderModal>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import {
  getVipUserListApi,
} from "@/api/vipOrderApi";
import {formatMoney} from "@/utils/formatMoney";
import {mapState} from "vuex";
import {Message} from "element-ui";
import vipOrderModal from "./vipOrderModal.vue"

export default {
  name: "",
  components: {Pagination,vipOrderModal},
  // 组件的props定义,用于子组件接收父组件传值
  props: {},
  computed: {
    ...mapState("user", ["role"]),
    sumMoney() {
      let sum = 0;
      this.tempArr.forEach((e) => {
        if (this.idArr.includes(e.orderNo)) {
          sum += e.totalMoneySupplyStr * 100;
        }
      });

      return sum / 100;
    },
  },
  // 组件的data属性
  data() {
    return {
      tempArr: [],
      idArr: [],
      checkboxInput: false,
      submitOrder: {
        id: "",
        expressNo: "",
        expressName: "",
        otherExpressNo: "",
      },
      updateOrderDeliveryObj: {
        id: "",
        title: "",
        price: "",
        supplyPrice: "",
        num: "",
        name: "",
        tel: "",
        address: "",
      },
      hidden: true,
      loading: false,
      page: 1,
      pageSize: 10,
      rows: [],
      expressList: [],
      visible: false,
      params: {
        pageIndex: 1,
        pageSize: 10,
        // 订单编号
        orderNo: "",
        // 订单状态
        orderStatus: "",
        // 开票状态
        invoiceState: "",
        // 订单日期
        startTime: "",
        endTime: "",
        // 下单人手机号
        telNum: this.userTel,
        // 订单类型
        orderType: "",
        // 商品来源
        fromType: "",
        isFp: "",
        // 商城id 在商城用
        wxShopId: this.currentWxShopId == null ? "" : this.currentWxShopId,
      },
      totalCount: 99999,
      bingId: -1,
      vipOrderVisible: false
    };
  },
  // 组件的方法
  methods: {

    copyText(text) {
      const textToCopy = text;

      // 创建一个临时的 textarea 元素
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;

      // 将 textarea 元素添加到 DOM 中
      document.body.appendChild(textarea);

      // 选中 textarea 中的文本
      textarea.select();

      // 执行复制操作
      document.execCommand('copy');

      // 移除 textarea 元素
      document.body.removeChild(textarea);
      Message.success('复制成功')
    },

    checkboxInputEvent() {
      if (this.checkboxInput) {
        this.rows.forEach((e) => {
          if (e.orderTypeName == "待付款" && e.dataFrom == 2) {
            if (!this.idArr.includes(e.orderNo)) {
              this.idArr.push(e.orderNo);
            }
          }
        });
      } else {
        this.rows.forEach((e) => {
          if (e.orderTypeName == "待付款" && e.dataFrom == 2) {
            let index = this.idArr.indexOf(e.orderNo);
            if (index !== -1) {
              this.idArr.splice(index, 1);
            }
          }
        });
      }
      this.$emit("setIdArr", this.idArr);
    },
    addIdArr(id) {
      if (this.idArr.includes(id)) {
        let index = this.idArr.indexOf(id);
        if (index !== -1) {
          this.idArr.splice(index, 1);
        }
      } else {
        this.idArr.push(id);
      }
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArr.includes(e.orderNo)) {
          a = false;
        }
      });
      this.$emit("setIdArr", this.idArr);
      this.$emit("setMoney", this.sumMoney);
      this.checkboxInput = a;
    },



    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },
    async getVipOrderList() {
      this.loading = true;
      let {data} = await getVipUserListApi(this.params);
      this.rows = data.data;
      this.totalCount = data.recordsTotal;
      this.loading = false;

      let a = true;
      let b = 0;
      // this.rows.forEach((e) => {
      //   if (e.orderTypeName == "待付款" && e.dataFrom == 2) {
      //     b++;
      //     if (!this.idArr.includes(e.id)) {
      //       a = false;
      //     }
      //   }
      // });
      if (b == 0) {
        a = false;
      }
      // this.tempArr.push(...this.rows);
      //
      // this.tempArr = this.tempArr.filter((item, index, self) => {
      //   return (
      //       index ===
      //       self.findIndex(
      //           (t) => t.orderNo === item.orderNo // 根据对象的id属性来判断是否重复
      //       )
      //   );
      // });
      this.checkboxInput = a;
      // this.params.orderDateRangee = data;
    },
    pageChange(currentPage, pageSize) {
      this.params.pageIndex = currentPage;
      this.params.pageSize = pageSize;
      this.getVipOrderList();
    },
    findOrder(params) {

      this.params = params;
      this.idArr = [];
      this.$emit("setIdArr", this.idArr);
      if (params.pageIndex != 1) {
        this.$refs.Pagination.goToPage(1);
      } else {
        this.getVipOrderList();
      }
    },
    formatM(num) {
      if (!isNaN(num)) {
        return formatMoney(num);
      }
      if (num == null) {
        return "-";
      }
      return num;
    },
    editGoods(bingId) {
      this.bingId = bingId
      this.vipOrderVisible = true
    },

  },
  filters: {
    format(num) {
      if (!isNaN(num)) {
        return formatMoney(num);
      }
      if (num == null) {
        return "-";
      }
      return num;
    },
  },
  // 在created钩子中执行的操作
  created() {
    this.getVipOrderList();
  },
  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件
    // this.rows.forEach((_, index) => {
    //   this.toggleDropdown(index);
    // });
  },
};
</script>

<!-- 组件的样式 -->
<style scoped>
</style>
